import ServiceBase from './serviceBase';
import { AdminConfigureResponse, GeneralSetting, RolePermissionUser } from './types/Admin';
import { ExternalApiLogFilter, ExternalApiLogList } from './types/ExternalApiLog';
import { User } from './types/User';

class AdminService extends ServiceBase {
  getUserConfigurations = async (): Promise<RolePermissionUser[]> =>
    this.get<RolePermissionUser[]>(`admin/users`);

  getUsersForAdd = async (): Promise<User[]> => this.get<User[]>(`admin/usersForAdd`);

  saveConfiguration = async (conf: RolePermissionUser[]): Promise<AdminConfigureResponse> =>
    this.post<AdminConfigureResponse>('admin/configure', conf);

  getGeneralSettings = async (): Promise<GeneralSetting[]> =>
    this.get<GeneralSetting[]>('admin/general-settings');

  updateGeneralSetting = async (id: number, dto: GeneralSetting): Promise<void> =>
    this.put(`admin/general-settings/${id}`, dto);

  getExternalApiLogs = async (filter: ExternalApiLogFilter): Promise<ExternalApiLogList> => {
    const { pageSize, pageNumber, includeSuccess } = filter;
    const queryParams = `pageNumber=${pageNumber}&pageSize=${pageSize}&includeSuccess=${includeSuccess}`;
    return this.get<ExternalApiLogList>(`admin/api-logs?${queryParams}`);
  };

  retryExternalApiLog = async (id: number): Promise<void> =>
    this.post(`admin/api-logs/retry/${id}`);

  deleteExternalApiLog = async (id: number): Promise<void> =>
    this.post(`admin/api-logs/delete/${id}`);
}

const adminService = new AdminService();

export default adminService;
